import { Collapse } from 'antd';
import CardHeader from '../card-utils/card-header';
import styles from './styles.module.scss';

import { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  NumberOfCoreSKillContext,
  NumberOfEducationContext,
  NumberOfExperienceContext,
  NumberOfPlanContext,
  NumberOfSoftSkillontext,
} from '../../../../context';
import AchievementCard from '../card-utils/card-detail/achievement';
import SkillCard from '../card-utils/card-detail/core-skills';
import EducationCard from '../card-utils/card-detail/education';
import ExperienceCard from '../card-utils/card-detail/experience';
import PlanCard from '../card-utils/card-detail/plan';
import ProjectCard from '../card-utils/card-detail/projects';
import SoftSkillCard from '../card-utils/card-detail/soft-skills';
import StrengthPassionsCard from '../card-utils/card-detail/strength-passion';
const { Panel } = Collapse;
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;
const StyledPanel = styled(Panel)`
  .ant-collapse-content {
    border-radius: 0 0 8px 8px;
    border-top: none;
  }
`;

const StyledCollapse = styled(Collapse)`
  .ant-collapse-item {
    border-bottom: none;
  }
  .ant-collapse-expand-icon {
    margin-top: 8px;
  }
`;
//Its the component for full view of collapsible sections. This component contains all of the collapsible cards.
export default function RightPanelAccordion() {
  const [numberOfPlans, setNumberOfPlans] = useState<number>();
  const [numberOfCoreSkills, setNumberOfCoreSkills] = useState<number>();
  const [numberOfSoftSkills, setNumberOfSoftSkills] = useState<number>();
  const [numberOfEducation, setNumberOfEducation] = useState<number>();
  const [numberOfExperience, setNumberOfExperience] = useState<number>();

  useEffect(() => {
    console.log('');
  }, [numberOfPlans]);
  return (
    <>
      <NumberOfCoreSKillContext.Provider
        value={{ numberOfCoreSkills, setNumberOfCoreSkills }}
      >
        <NumberOfSoftSkillontext.Provider
          value={{ numberOfSoftSkills, setNumberOfSoftSkills }}
        >
          <NumberOfPlanContext.Provider
            value={{ numberOfPlans, setNumberOfPlans }}
          >
            <NumberOfEducationContext.Provider
              value={{ numberOfEducation, setNumberOfEducation }}
            >
              <NumberOfExperienceContext.Provider
                value={{ numberOfExperience, setNumberOfExperience }}
              >
                <StyledCollapse
                  accordion
                  expandIcon={({ isActive }) => {
                    return (
                      <>
                        {isActive ? (
                          <img
                            src="/expand_more_dark.png"
                            style={{ transform: 'rotateZ(-180deg)' }}
                          />
                        ) : (
                          <img
                            src="/expand_more_dark.png"
                            style={{ transform: 'rotateZ(0deg)' }}
                          />
                        )}
                      </>
                    );
                  }}
                  expandIconPosition="end"
                  defaultActiveKey={'1'}
                  style={{
                    marginRight: '8px',
                    marginTop: '106px',
                    marginLeft: '360px',
                    width: '100%',
                    background: '#F9FAFD',
                    border: 'none',
                    minHeight: '100vh',
                    minWidth: '600px',
                  }}
                >
                  <StyledPanel
                    className={styles.panel}
                    header={
                      <CardHeader
                        type={'Plans'}
                        name="Plans"
                        numberOfItems={numberOfPlans}
                      />
                    }
                    key="1"
                    style={{ marginBottom: 15 }}
                  >
                    <PlanCard />
                  </StyledPanel>
                  <StyledPanel
                    className={styles.panel}
                    header={
                      <CardHeader
                        type={'Core Skills'}
                        name="Core Skills"
                        numberOfItems={numberOfCoreSkills}
                      />
                    }
                    key="2"
                    style={{ marginBottom: 15 }}
                  >
                    <SkillCard />
                  </StyledPanel>
                  <StyledPanel
                    className={styles.panel}
                    header={
                      <CardHeader
                        type={'Soft Skills'}
                        name="Soft Skills"
                        numberOfItems={numberOfSoftSkills}
                      />
                    }
                    key="3"
                    style={{ marginBottom: 15 }}
                  >
                    <SoftSkillCard />
                  </StyledPanel>
                  <StyledPanel
                    className={styles.panel}
                    header={
                      <CardHeader
                        type={'Experiences'}
                        name="Experiences"
                        numberOfItems={numberOfExperience}
                      />
                    }
                    key="4"
                    style={{ marginBottom: 15 }}
                  >
                    <ExperienceCard />
                  </StyledPanel>
                  <StyledPanel
                    className={styles.panel}
                    header={
                      <CardHeader
                        type={'Educational Qualifications'}
                        name="Educational Qualifications"
                        numberOfItems={numberOfEducation}
                      />
                    }
                    key="5"
                    style={{ marginBottom: 15 }}
                  >
                    <EducationCard />
                  </StyledPanel>

                  <StyledPanel
                    className={styles.panel}
                    header={
                      <CardHeader
                        type={'Project'}
                        name="Project"
                        numberOfItems={numberOfEducation}
                      />
                    }
                    key="6"
                    style={{ marginBottom: 15 }}
                  >
                    <ProjectCard />
                  </StyledPanel>

                  <StyledPanel
                    className={styles.panel}
                    header={
                      <CardHeader
                        type={'Achievement'}
                        name={'Achievements/Certifications'}
                        numberOfItems={numberOfEducation}
                      />
                    }
                    key="7"
                    style={{ marginBottom: 15 }}
                  >
                    <AchievementCard />
                  </StyledPanel>

                  <StyledPanel
                    className={styles.panel}
                    header={
                      <CardHeader
                        type={'Strength'}
                        name={'Strength/Passion'}
                        numberOfItems={numberOfEducation}
                      />
                    }
                    key="8"
                    style={{ marginBottom: 15 }}
                  >
                    <StrengthPassionsCard />
                  </StyledPanel>
                </StyledCollapse>
              </NumberOfExperienceContext.Provider>
            </NumberOfEducationContext.Provider>
          </NumberOfPlanContext.Provider>
        </NumberOfSoftSkillontext.Provider>
      </NumberOfCoreSKillContext.Provider>
    </>
  );
}
